import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRemoveCostProfileFromResourceRequest(
  state: State,
  resource: Boundaries["removeCostProfileFromResource"]["request"],
): State {
  const index = state.findIndex((req) => req.resource.uuid === resource.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { resource, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { resource, request: setRequestStateToPending() }];
}

function handleRemoveCostProfileFromResourceSuccess(
  state: State,
  resource: Boundaries["removeCostProfileFromResource"]["success"],
): State {
  const index = state.findIndex((req) => req.resource.uuid === resource.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { resource, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { resource, request: setRequestStateToSuccess() }];
}

function handleRemoveCostProfileFromResourceFailure(
  state: State,
  resource: Boundaries["removeCostProfileFromResource"]["request"],
): State {
  const index = state.findIndex((req) => req.resource.uuid === resource.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { resource, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { resource, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeCostProfileFromResourceRequested]:
      handleRemoveCostProfileFromResourceRequest,
    [events.removeCostProfileFromResourceSucceeded]:
      handleRemoveCostProfileFromResourceSuccess,
    [events.removeCostProfileFromResourceFailed]:
      handleRemoveCostProfileFromResourceFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
